import EmptyResult from "components/others/EmptyResult";
import ObjectsTableRows from "./ObjectsTableRows";
import { useEffect, useState } from "react";
import ObjectDetailsOffcanvas from "../../ObjectDetails/ObjectDetailsOffcanvas";
import { useObject } from "../context/ObjectProvider";
import { useAuth } from "context/AuthContext";
import { isManagerUser } from "utils/helpers/access/hasUserAccess";
import * as apiObject from "api/apiObjects";

const ObjectsTableBody = ({objectsList, fetchObjects, setClientInfoId, setTasksObjectId}) => {
    const { auth } = useAuth();
    const [specificationObject, setSpecificationObject] = useState(null);
    const [accessObject, setAccessObject] = useState(null);
    const [AccessOffcanvas, setAccessOffcanvas] = useState(null);
    const { showDebtor, showClient, showTeam, showCreated, showAccess, showInWork } = useObject();
    const colSpan = 5
        + (showCreated ? 1 : 0)
        + (showAccess ? 1 : 0)
        + (showInWork ? 1 : 0)
        + (showClient ? 1 : 0)
        + (showDebtor ? 1 : 0)
        + (showTeam ? 1 : 0);

    useEffect(() => {
        if (!accessObject) return;
        const fresh = objectsList?.find((item) => item.ID === accessObject.ID);
        if (!fresh) return;
        const sign = (rows) => (rows || []).map((grant) => `${grant.ID}:${grant.accessLevel}`).sort().join('|');
        if (sign(accessObject.accessUsers) !== sign(fresh.accessUsers)) setAccessObject(fresh);
    }, [objectsList, accessObject]);

    const openAccess = async (vobject) => {
        if (!AccessOffcanvas) {
            const module = await import('modules/lead');
            setAccessOffcanvas(() => module.RecordAccessOffcanvas);
        }
        setAccessObject(vobject);
    };

    return (<>
        <tbody>
        {objectsList && objectsList?.map(vobject=>{
            return (
                <ObjectsTableRows
                    setClientInfoId={setClientInfoId}
                    setTasksObjectId={setTasksObjectId}
                    key={vobject.ID}
                    vobject={vobject}
                    onShowSpecification={setSpecificationObject}
                    onOpenAccess={openAccess}
                    fetchObjects={fetchObjects}/>
            )
        })}

        {objectsList.length === 0  && (
            <tr>
                <td colSpan={colSpan}>
                    <EmptyResult/>
                </td>
            </tr>)}

        </tbody>

        <ObjectDetailsOffcanvas
            show={!!specificationObject}
            onHide={() => setSpecificationObject(null)}
            vobject={specificationObject}
        />
        {accessObject && AccessOffcanvas ? (
            <AccessOffcanvas
                show
                setShow={(next) => {
                    if (!next) setAccessObject(null);
                }}
                grants={accessObject.accessUsers || []}
                ownerId={accessObject.ownerId}
                ownerName={accessObject.userName}
                ownerEmail={accessObject.userEmail}
                ownerPicture={accessObject.userPicture}
                canManage={isManagerUser(auth?.user)}
                onSave={async (grants) => {
                    const ok = await apiObject.setObjectAccess(accessObject.ID, grants);
                    if (ok) await fetchObjects?.(true);
                    return Boolean(ok);
                }}
            />
        ) : null}
        
    </>) 
}

export default ObjectsTableBody; 